import React from 'react';
import {View} from 'react-native';
import Label from '../../Label';

export const Header = () => {
  return (
    <View>
      <Label title={'SOUSCRIPTION ASSURANCE RETRAITE'} type="mainTitle" />
      <Label
        type="secondTitle"
        title={'Pour souscrire, veuillez remplir les champs manquants'}
      />
    </View>
  );
};
